import React from 'react';

export default function isEnterPressed(event: React.KeyboardEvent): boolean {
  if (event.key === 'Enter' || event.keyCode === 13) {
    event.preventDefault();
    return true;
  }
  return false;
}
